import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Stack,
  Button,
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
} from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useJobType } from "../../contexts/JobTypeContext";
import Logo from "./logo-white.png";

const Header = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const { jobType, setJobType } = useJobType();

  // Handle dropdown change
  const handlePATypeChange = (event: SelectChangeEvent<string>) => {
    const newValue = event.target.value as 'sold' | 'spec';
    setJobType(newValue);
    
    // Determine which page to navigate to based on current route
    const currentPath = location.pathname;
    
    if (currentPath.includes('/create')) {
      navigate(`/${newValue}/create`);
    } else if (currentPath.includes('/edit/')) {
      // For edit, go to list since the ID won't be valid for different job type
      navigate(`/${newValue}`);
    } else if (currentPath.includes('/view/')) {
      // For view, go to list since the ID won't be valid for different job type
      navigate(`/${newValue}`);
    } else {
      // Default to list page
      navigate(`/${newValue}`);
    }
  };

  return (
    <AppBar
      elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar>
        <Box display="flex" flex={1} justifyContent="space-between" alignItems="center">
          <Stack direction="row" spacing={1}>
            <Link to="/">
              <img src={Logo} height={60} alt="logo" />
            </Link>
            <Box
              mx={2}
              flex={1}
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <Typography variant="h6">Profit Analysis</Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <Select
                value={jobType}
                onChange={handlePATypeChange}
                sx={{
                  color: (theme) => theme.palette.common.white,
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: (theme) => theme.palette.common.white,
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: (theme) => theme.palette.common.white,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: (theme) => theme.palette.common.white,
                  },
                  ".MuiSvgIcon-root": {
                    color: (theme) => theme.palette.common.white,
                  },
                }}
              >
                <MenuItem value="sold">Sold Job</MenuItem>
                <MenuItem value="spec">Spec Job</MenuItem>
              </Select>
            </FormControl>

            <Button
              variant="outlined"
              sx={{ color: (theme) => theme.palette.common.white }}
              onClick={() =>
                instance.logoutRedirect({
                  postLogoutRedirectUri: "/",
                })
              }
            >
              Logout
            </Button>
          </Stack>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;